import HomeworkStatusNavigation from "@/views/settings/views/homework-status/navigation/homework-status.nav";
import EntityGroupNavigation from "@/views/settings/views/entity-group/navigation/entity-group.nav.js";

const navigation = [
    {
        header: 'SETTINGS'
    },
    // HomeworkStatusNavigation,
    // EntityGroupNavigation,
];

export default navigation;